import React from 'react';

export const SettingsUsersStatusConfirmModal = ({
    open,
    user,
    nextActive,
    isSaving,
    onCancel,
    onConfirm,
}) => {
    if (!open) {
        return null;
    }

    return (
        <div className="settings-users-modal-backdrop" role="presentation">
            <div className="settings-users-modal" role="dialog" aria-modal="true" aria-labelledby="settings-users-confirm-title">
                <h6 id="settings-users-confirm-title" className="mb-2">Confirmar acción</h6>
                <p className="text-muted mb-3">
                    ¿Deseas {nextActive ? 'activar' : 'desactivar'} a <strong>{user?.name || 'este usuario'}</strong>?
                </p>
                <div className="d-flex justify-content-end gap-2">
                    <button type="button" className="btn btn-light-brand btn-sm" onClick={onCancel} disabled={isSaving}>
                        Cancelar
                    </button>
                    <button
                        type="button"
                        className={`btn btn-sm ${nextActive ? 'btn-success' : 'btn-light-danger'}`}
                        onClick={onConfirm}
                        disabled={isSaving}
                    >
                        {isSaving ? 'Procesando...' : (nextActive ? 'Activar' : 'Desactivar')}
                    </button>
                </div>
            </div>
        </div>
    );
};
